import { render, staticRenderFns } from "./fromZJ.vue?vue&type=template&id=33355944"
import script from "./fromZJ.vue?vue&type=script&lang=js"
export * from "./fromZJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports